import { Checkbox } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { que2ValueProps } from '../../MaximoJourneyAdvisor';
import { segmentsTracking } from 'src/common/lib/tracker';
import './Step.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/maximo-journey-advisor/locales/messages';
import { businessChallengeOption } from 'src/apps/maximo-journey-advisor/constants/default';

type Step2Props = {
  que2Value: que2ValueProps;
  setQue2Value: React.Dispatch<React.SetStateAction<que2ValueProps>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  checkboxState: boolean;
};

const Step2 = ({
  que2Value,
  setQue2Value,
  setIsRequired,
  checkboxState,
}: Step2Props) => {
  const intl = useIntl();
  const handleCheck = (checked: boolean, value: string, id: string) => {
    setIsRequired(false);
    if (checked) {
      setQue2Value({
        ...que2Value,
        options: {
          ...que2Value.options,
          [id]: {
            value: value,
            checked: true,
          },
        },
      });
    } else {
      setQue2Value({
        ...que2Value,
        options: {
          ...que2Value.options,
          [id]: {
            value: '',
            checked: false,
          },
        },
      });
    }
    segmentsTracking('CTA Clicked', {
      pageTitle: 'Maximo Journey Advisor Assessment',
      object: 'Maximo Journey Advisor page',
      resultValue: 'CTA clicked',
      CTA: `Business Challenge ${value} Checkbox`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  useEffect(() => {
    if (checkboxState) {
      setIsRequired(false);
    } else {
      setIsRequired(true);
    }
  }, [checkboxState]);

  return (
    <div className="step2">
      <div className="page_heading_3 mt-01">
        <FormattedMessage {...messages.question2_title} />
      </div>
      <div className="select-text">
        <FormattedMessage {...messages.select_text} />
      </div>
      <div className="bx--row mt-01">
        <div className="bx--col-lg-8 bx--col-md-6 bx--col-sm-4">
          <Checkbox
            labelText={intl.formatMessage(messages.question2_opt1)}
            id="Q2A1"
            checked={que2Value.options.Q2A1.checked}
            onChange={(checked: boolean, id: string) =>
              handleCheck(checked, businessChallengeOption.opt1, id)
            }
          />
          <div className="info-text">
            <FormattedMessage {...messages.question2_opt1_info} />
          </div>
          <div className="mt-02">
            <Checkbox
              labelText={intl.formatMessage(messages.question2_opt3)}
              id="Q2A3"
              checked={que2Value.options.Q2A3.checked}
              onChange={(checked: boolean, id: string) =>
                handleCheck(checked, businessChallengeOption.opt3, id)
              }
            />
            <div className="info-text">
              <FormattedMessage {...messages.question2_opt3_info} />
            </div>
          </div>
        </div>
        <div className="bx--col-lg-8 bx--col-md-6 bx--col-sm-4">
          <Checkbox
            labelText={intl.formatMessage(messages.question2_opt2)}
            id="Q2A2"
            checked={que2Value.options.Q2A2.checked}
            onChange={(checked: boolean, id: string) =>
              handleCheck(checked, businessChallengeOption.opt2, id)
            }
          />
          <div className="info-text">
            <FormattedMessage {...messages.question2_opt2_info} />
          </div>
          <div className="mt-02">
            <Checkbox
              labelText={intl.formatMessage(messages.question2_opt4)}
              id="Q2A4"
              checked={que2Value.options.Q2A4.checked}
              onChange={(checked: boolean, id: string) =>
                handleCheck(checked, businessChallengeOption.opt4, id)
              }
            />{' '}
            <div className="info-text">
              <FormattedMessage {...messages.question2_opt4_info} />
            </div>{' '}
          </div>
        </div>
        <div className="bx--col-lg-8 bx--col-md-6 bx--col-sm-4 mt-02">
          <Checkbox
            labelText={intl.formatMessage(messages.question2_opt5)}
            id="Q2A5"
            checked={que2Value.options.Q2A5.checked}
            onChange={(checked: boolean, id: string) =>
              handleCheck(checked, businessChallengeOption.opt5, id)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Step2;
